import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { EmptyText } from "@/components/EmptyText";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_XS } from "@/core/media";
import { Flex, Group } from "@/eworkitComponents";

import { ICompanySectionProps } from "../types";
import { CompanyWebsiteEdit } from "./CompanyWebsiteEdit";

interface ICompanyWebsiteSectionProps extends ICompanySectionProps, IEditableSectionRenderProps {}

export const CompanyWebsiteSection: FC<ICompanyWebsiteSectionProps> = props => {
  const isVerySmallScreen = useMedia(MEDIA_SIZE_XS);
  const { t } = useTranslation("session");

  return props.editableProps.editMode ? (
    <CompanyWebsiteEdit
      editableProps={props.editableProps}
      source={props.record}
      initialValues={{ companyWebsite: props.record.companyWebsite }}
      onUpdate={props.onUpdate}
      onCancel={props.editableProps.handleCancelClick}
    />
  ) : (
    <Flex direction={isVerySmallScreen ? "column" : "row"} innerMargin="md">
      <Flex direction="column" width={{ xxs: 12, md: 5 }}>
        <Group label={t("COMPANY.CREATE.WEBSITE")} direction="column">
          <Text size="md" color="black">
            {props.record.companyWebsite ? props.record.companyWebsite : <EmptyText />}
          </Text>
        </Group>
      </Flex>
    </Flex>
  );
};
